//key signatures
import A_maj_key_sig from "../app/images/Key-Signatures-Hig-Res-Images/A-maj-key-sig.png";
import Ab_maj_key_sig from "../app/images/Key-Signatures-Hig-Res-Images/Ab-maj-key-sig.png";
import B_maj_key_sig from "../app/images/Key-Signatures-Hig-Res-Images/B-maj-key-sig.png";
import Bb_maj_key_sig from "../app/images/Key-Signatures-Hig-Res-Images/Bb-maj-key-sig.png";
import C_maj_key_sig from "../app/images/Key-Signatures-Hig-Res-Images/c-maj-key-sig.png";
import Csharp_maj_key_sig from "../app/images/Key-Signatures-Hig-Res-Images/Csharp-maj-key-sig.png";
import Cb_maj_key_sig from "../app/images/Key-Signatures-Hig-Res-Images/Cb-maj-key-sig.png";
import D_maj_key_sig from "../app/images/Key-Signatures-Hig-Res-Images/D-maj-key-sig.png";
import Db_maj_key_sig from "../app/images/Key-Signatures-Hig-Res-Images/Db-maj-key-sig.png";
import E_maj_key_sig from "../app/images/Key-Signatures-Hig-Res-Images/E-maj-key-sig.png";
import Eb_maj_key_sig from "../app/images/Key-Signatures-Hig-Res-Images/Eb-maj-key-sig.png";
import F_maj_key_sig from "../app/images/Key-Signatures-Hig-Res-Images/f-maj-key-sig.png";
import Fsharp_maj_key_sig from "../app/images/Key-Signatures-Hig-Res-Images/Fsharp-maj-key-sig.png";
import G_maj_key_sig from "../app/images/Key-Signatures-Hig-Res-Images/G-maj-key-sig.png";
import Gb_maj_key_sig from "../app/images/Key-Signatures-Hig-Res-Images/Gb-maj-key-sig.png";



//Ascending major intervals
//maj 2nds
import Ascending_Maj_2nd_C_to_D from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Maj-2nds/CtoD.png";
import Ascending_Maj_2nd_E_to_Fsharp from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Maj-2nds/EtoFsharp.png";
import Ascending_Maj_2nd_Fsharp_to_Gsharp from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Maj-2nds/FsharpToGsharp.png";
import Ascending_Maj_2nd_F_to_G from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Maj-2nds/FtoG.png";

//maj 3rds
import Ascending_Maj_3rd_D_to_Fsharp from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Maj-3rds/DtoFsharp.png";
import Ascending_Maj_3rd_Eb_to_G from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Maj-3rds/EbToG.png";
import Ascending_Maj_3rd_High_Bb_to_D from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Maj-3rds/HighBbToD.png";
import Ascending_Maj_3rd_High_D_to_Fsharp from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Maj-3rds/HighDtoFsharp.png";
import Ascending_Maj_3rd_Low_B_to_Dsharp from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Maj-3rds/lowBtoDsharp.png";

//perfect 4ths
import Ascending_Perf_4th_BtoE from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Perf-4ths/BtoE.png";
import Ascending_Perf_4th_EbToAb from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Perf-4ths/EbtoAb.png";
import Ascending_Perf_4th_FsharpToB from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Perf-4ths/FsharpToB.png";
import Ascending_Perf_4th_FtoBb from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Perf-4ths/FtoBb.png";

//perfect 5ths
import Ascending_Perf_5th_CsharpToGsharp from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Perf-5ths/CsharpToGsharp.png";
import Ascending_Perf_5th_FsharpToCsharp from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Perf-5ths/FsharpToCsharp.png";
import Ascending_Perf_5th_HighGtoHighC from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Perf-5ths/HighGtoHighC.png";
import Ascending_Perf_5th_LowCtoG from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Perf-5ths/LowCtoG.png";

//major 6ths
import Ascending_Maj_6th_Eb_to_C from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Maj-6ths/EbtoC.png";
import Ascending_Maj_6th_Fsharp_to_Dsharp from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Maj-6ths/FsharpToDsharp.png";
import Ascending_Maj_6th_High_F_to_D from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Maj-6ths/HighFtoD.png";
import Ascending_Maj_6th_Low_Bb_to_G from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Maj-6ths/LowBbtoG.png";
import Ascending_Maj_6th_E_to_Csharp from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Maj-6ths/LowEtoCsharp.png";

//major 7ths
import Ascending_Maj_7th_Bb_to_A from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Maj-7ths/BbtoA.png";
import Ascending_Maj_7th_Low_B_to_Asharp from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Maj-7ths/LowBtoAsharp.png";
import Ascending_Maj_7th_LowF_to_E from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Maj-7ths/LowFtoE.png";
import Ascending_Maj_7th_Low_Csharp_to_C from "../app/images/High-Res-Interval-Pics/Ascending-Major-Intervals/Ascending-Maj-7ths/LowCsharpToC.png";

//Descending Major Intervals
//major 2nds
import Descending_Maj_2nd_AsharpToGsharp from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Maj-2nd/AsharpToGsharpDesc.png";
import Descending_Maj_2nd_Gsharp_to_Fsharp from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Maj-2nd/GsharpToFsharpDesc.png";
import Descending_Maj_2nd_G_to_F from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Maj-2nd/GtoFdesc.png";
import Descending_Maj_2nd_High_Csharp_to_B from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Maj-2nd/HighCsharpToBdesc.png";
import Descending_Maj_2nd_High_Dsharp_to_Csharp from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Maj-2nd/HighDsharpToCsharpDesc.png";
import Descending_Maj_2nd_High_E_to_C from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Maj-2nd/HighEtoDdesc.png";
import Descending_Maj_2nd_Low_C_to_Bb from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Maj-2nd/LowCtoBbDesc.png";

//major 3rds
import Descending_Maj_3rd_Csharp_to_A from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Maj-3rds/CsharpToAdesc.png";
import Descending_Maj_3rd_F_to_Db from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Maj-3rds/FtoDbDesc.png";
import Descending_Maj_3rd_High_B_to_G from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Maj-3rds/HighBtoGDesc.png";
import Descending_Maj_3rd_Low_D_to_Bb from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Maj-3rds/LowDtoBbDesc.png";

//perfect 4ths
import Descending_Perf_4th_Csharp_to_Gsharp from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Perf-4ths/CsharpToGsharpDesc.png";
import Descending_Perf_4th_E_to_A from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Perf-4ths/EtoAdesc.png";
import Descending_Perf_4th_High_Eb_to_Bb from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Perf-4ths/HighEbToBbDesc.png";
import Descending_Perf_4th_High_F_to_C from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Perf-4ths/HighFtoCdesc.png";

//perfect 5ths
import Descending_Perf_5th_D_to_G from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Perf-5ths/DtoGdesc.png";
import Descending_Perf_5th_Gsharp_to_Csharp from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Perf-5ths/GsharpToCsharpDesc.png";
import Descending_Perf_5th_High_F_to_Bb from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Perf-5ths/HighFtoBbdesc.png";
import Descending_Perf_5th_Low_Fsharp_to_B from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Perf-5ths/LowFsharpToBDesc.png";

//major 6ths
import Descending_Maj_6th_Bb_to_Db from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Maj-6ths/BbtoDbDesc.png";
import Descending_Maj_6th_G_to_Low_Bb from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Maj-6ths/GtoLowBbDesc.png";
import Descending_Maj_6th_High_D_to_F from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Maj-6ths/HighDtoFdesc.png";
import Descending_Maj_6th_High_E_to_G from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Maj-6ths/HighEtoGdesc.png";

//major 7ths
import Descending_Maj_7th_Asharp_to_Low_B from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Maj-7ths/AsharpToLowBdesc.png";
import Descending_Maj_7th_F_to_Fsharp from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Maj-7ths/FtoFsharpDesc.png";
import Descending_Maj_7th_G_to_Ab from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Maj-7ths/GtoAbDesc.png";
import Descending_Maj_7th_High_E_to_F from "../app/images/High-Res-Interval-Pics/Descending-Major-Intervals/Descending-Maj-7ths/HighEtoFDesc.png";

//ascending chromatic intervals
//minor 2nds
import Ascending_Chromatic_Min_2nd_High_Asharp_to_B from "../app/images/High-Res-Interval-Pics/Ascending-Chromatic-Intervals/Ascending-min-2nds/HighAsharpToB.png";
import Ascending_Chromatic_Min_2nd_High_D_to_Eb from "../app/images/High-Res-Interval-Pics/Ascending-Chromatic-Intervals/Ascending-min-2nds/HighDtoEb.png";
import Ascending_Chromatic_Min_2nd_Low_C_to_Csharp from "../app/images/High-Res-Interval-Pics/Ascending-Chromatic-Intervals/Ascending-min-2nds/LowCtoCsharp.png";
import Ascending_Chromatic_Min_2nd_Low_F_to_Fsharp from "../app/images/High-Res-Interval-Pics/Ascending-Chromatic-Intervals/Ascending-min-2nds/LowFtoFsharp.png";

//minor 3rds
import Ascending_Chromatic_Min_3rd_C_sharp_to_E from "../app/images/High-Res-Interval-Pics/Ascending-Chromatic-Intervals/Ascending-min-3rds/CsharpToE.png";
import Ascending_Chromatic_Min_3rd_High_F_to_Ab from "../app/images/High-Res-Interval-Pics/Ascending-Chromatic-Intervals/Ascending-min-3rds/HighFtoAb.png";
import Ascending_Chromatic_Min_3rd_Low_B_to_D from "../app/images/High-Res-Interval-Pics/Ascending-Chromatic-Intervals/Ascending-min-3rds/LowBtoD.png";
import Ascending_Chromatic_Min_3rd_Low_Eb_to_Gb from "../app/images/High-Res-Interval-Pics/Ascending-Chromatic-Intervals/Ascending-min-3rds/LowEbToGb.png";

//augmented 4ths
import Ascending_Chromatic_Aug_4th_Bb_to_E from "../app/images/High-Res-Interval-Pics/Ascending-Chromatic-Intervals/Ascending-aug-4ths/BbtoE.png";
import Ascending_Chromatic_Aug_4th_B_to_F from "../app/images/High-Res-Interval-Pics/Ascending-Chromatic-Intervals/Ascending-aug-4ths/BtoF.png";
import Ascending_Chromatic_Aug_4th_E_to_Bb from "../app/images/High-Res-Interval-Pics/Ascending-Chromatic-Intervals/Ascending-aug-4ths/EtoBb.png";
import Ascending_Chromatic_Aug_4th_F_to_B from "../app/images/High-Res-Interval-Pics/Ascending-Chromatic-Intervals/Ascending-aug-4ths/FtoB.png";

//minor 6ths
import Ascending_Chromatic_Min_6th_A_to_F from "../app/images/High-Res-Interval-Pics/Ascending-Chromatic-Intervals/Ascending-minor-6ths/AtoF.png";
import Ascending_Chromatic_Min_6th_Csharp_to_A from "../app/images/High-Res-Interval-Pics/Ascending-Chromatic-Intervals/Ascending-minor-6ths/CsharpToA.png";
import Ascending_Chromatic_Min_6th_Low_Bb_to_Gb from "../app/images/High-Res-Interval-Pics/Ascending-Chromatic-Intervals/Ascending-minor-6ths/LowBbToGb.png";
import Ascending_Chromatic_Min_6th_Low_E_to_C from "../app/images/High-Res-Interval-Pics/Ascending-Chromatic-Intervals/Ascending-minor-6ths/LowEtoC.png";

//minor 7ths
import Ascending_Chromatic_Min_7th_E_to_D from "../app/images/High-Res-Interval-Pics/Ascending-Chromatic-Intervals/Ascending-Min-7ths/EtoD.png";
import Ascending_Chromatic_Min_7th_F_to_Eb from "../app/images/High-Res-Interval-Pics/Ascending-Chromatic-Intervals/Ascending-Min-7ths/FtoEb.png";
import Ascending_Chromatic_Min_7th_Low_Bb_to_Ab from "../app/images/High-Res-Interval-Pics/Ascending-Chromatic-Intervals/Ascending-Min-7ths/LowBbToAb.png";
import Ascending_Chromatic_Min_7th_Low_Csharp_to_B from "../app/images/High-Res-Interval-Pics/Ascending-Chromatic-Intervals/Ascending-Min-7ths/LowCsharpToB.png";

//descending chromatic intervals
//min 2nds
import Descending_Chromatic_Min_2nd_A_sharp_to_A from "../app/images/High-Res-Interval-Pics/Descending-Chromatic-Intervals/Descending-min-2nds/AsharpToAdesc.png";
import Descending_Chromatic_Min_2nd_E_to_Eb from "../app/images/High-Res-Interval-Pics/Descending-Chromatic-Intervals/Descending-min-2nds/EtoEbDesc.png";
import Descending_Chromatic_Min_2nd_F_to_E from "../app/images/High-Res-Interval-Pics/Descending-Chromatic-Intervals/Descending-min-2nds/FtoEdesc.png";
import Descending_Chromatic_Min_2nd_High_Fsharp_to_F from "../app/images/High-Res-Interval-Pics/Descending-Chromatic-Intervals/Descending-min-2nds/HighFsharpToFdesc.png";

//min 3rds
import Descending_Chromatic_Min_3rd_Ab_to_F from "../app/images/High-Res-Interval-Pics/Descending-Chromatic-Intervals/Descending-min-3rds/AflatToFdesc.png";
import Descending_Chromatic_Min_3rd_C_to_A from "../app/images/High-Res-Interval-Pics/Descending-Chromatic-Intervals/Descending-min-3rds/CtoAdesc.png";
import Descending_Chromatic_Min_3rd_Bb_to_G from "../app/images/High-Res-Interval-Pics/Descending-Chromatic-Intervals/Descending-min-3rds/HighBbToGdesc.png";
import Descending_Chromatic_Min_3rd_High_Csharp_to_A_sharp from "../app/images/High-Res-Interval-Pics/Descending-Chromatic-Intervals/Descending-min-3rds/HighCsharpToAsharpDesc.png";

//dim 4ths
import Descending_Chromatic_Dim_5th_B_to_F from "../app/images/High-Res-Interval-Pics/Descending-Chromatic-Intervals/Descending-dim-5ths/BtoFdesc.png";
import Descending_Chromatic_Dim_5th_D_to_Ab from "../app/images/High-Res-Interval-Pics/Descending-Chromatic-Intervals/Descending-dim-5ths/DtoAbDesc.png";
import Descending_Chromatic_Dim_5th_Eb_to_A from "../app/images/High-Res-Interval-Pics/Descending-Chromatic-Intervals/Descending-dim-5ths/EbToAdesc.png";
import Descending_Chromatic_Dim_5th_G_to_C_sharp from "../app/images/High-Res-Interval-Pics/Descending-Chromatic-Intervals/Descending-dim-5ths/GtoCsharpDesc.png";

//min 6ths
import Descending_Chromatic_Min_6th_A_to_Csharp from "../app/images/High-Res-Interval-Pics/Descending-Chromatic-Intervals/Descending-min-6ths/AtoLowCsharpDesc.png";
import Descending_Chromatic_Min_6th_G_to_B from "../app/images/High-Res-Interval-Pics/Descending-Chromatic-Intervals/Descending-min-6ths/GtoLowBdesc.png";
import Descending_Chromatic_Min_6th_High_A_to_C_sharp from "../app/images/High-Res-Interval-Pics/Descending-Chromatic-Intervals/Descending-min-6ths/HighAtoCsharpDesc.png";
import Descending_Chromatic_Min_6th_D_to_Fsharp from "../app/images/High-Res-Interval-Pics/Descending-Chromatic-Intervals/Descending-min-6ths/HighDtoFsharpDesc.png";

//min 7ths
import Descending_Chromatic_Min_7th_B_to_Csharp from "../app/images/High-Res-Interval-Pics/Descending-Chromatic-Intervals/Descending-min-7ths/BtoLowCsharpDesc.png";
import Descending_Chromatic_Min_7th_C_to_D from "../app/images/High-Res-Interval-Pics/Descending-Chromatic-Intervals/Descending-min-7ths/CtoLowDdesc.png";
import Descending_Chromatic_Min_7th_Ab_to_Bb from "../app/images/High-Res-Interval-Pics/Descending-Chromatic-Intervals/Descending-min-7ths/HighAbtoBbDesc.png";
import Descending_Chromatic_Min_7th_F_to_G from "../app/images/High-Res-Interval-Pics/Descending-Chromatic-Intervals/Descending-min-7ths/HighFtoGdesc.png";

//modes
//ionian
import Ionian_Mode_Ab from "../app/images/High-res-major-scale-modes/ionian/Ab.png";
import Ionian_Mode_Csharp from "../app/images/High-res-major-scale-modes/ionian/Csharp.png";
import Ionian_Mode_Db from "../app/images/High-res-major-scale-modes/ionian/Db.png";
import Ionian_Mode_E from "../app/images/High-res-major-scale-modes/ionian/E.png";

//dorian
import Dorian_Mode_B from "../app/images/High-res-major-scale-modes/dorian/B.png";
import Dorian_Mode_D from "../app/images/High-res-major-scale-modes/dorian/D.png";
import Dorian_Mode_Eb from "../app/images/High-res-major-scale-modes/dorian/Eb.png";
import Dorian_Mode_F from "../app/images/High-res-major-scale-modes/dorian/F.png";

//phrygian
import Phrygian_Mode_Asharp from "../app/images/High-res-major-scale-modes/phrygian/Asharp.png";
import Phrygian_Mode_C from "../app/images/High-res-major-scale-modes/phrygian/C.png";
import Phrygian_Mode_E from "../app/images/High-res-major-scale-modes/phrygian/E.png";
import Phrygian_Mode_Fsharp from "../app/images/High-res-major-scale-modes/phrygian/Fsharp.png";

//lydian
import Lydian_Mode_B from "../app/images/High-res-major-scale-modes/lydian/B.png";
import Lydian_Mode_Eb from "../app/images/High-res-major-scale-modes/lydian/Eb.png";
import Lydian_Mode_F from "../app/images/High-res-major-scale-modes/lydian/F.png";
import Lydian_Mode_Bb from "../app/images/High-res-major-scale-modes/lydian/Bb.png";

//mixolydian
import Mixo_Mode_Bb from "../app/images/High-res-major-scale-modes/mixolydian/Bb.png";
import Mixo_Mode_E from "../app/images/High-res-major-scale-modes/mixolydian/E.png";
import Mixo_Mode_Fsharp from "../app/images/High-res-major-scale-modes/mixolydian/Fsharp.png";
import Mixo_Mode_C from "../app/images/High-res-major-scale-modes/mixolydian/C.png";

//aeolian
import Aeolian_Mode_B from "../app/images/High-res-major-scale-modes/aeolian/B.png";
import Aeolian_Mode_C from "../app/images/High-res-major-scale-modes/aeolian/C.png";
import Aeolian_Mode_D from "../app/images/High-res-major-scale-modes/aeolian/D.png";
import Aeolian_Mode_Gsharp from "../app/images/High-res-major-scale-modes/aeolian/Gsharp.png";

//locrian
import Locrian_Mode_Asharp from "../app/images/High-res-major-scale-modes/locrian/Asharp.png";
import Locrian_Mode_Bsharp from "../app/images/High-res-major-scale-modes/locrian/Bsharp.png";
import Locrian_Mode_D from "../app/images/High-res-major-scale-modes/locrian/D.png";
import Locrian_Mode_Fsharp from "../app/images/High-res-major-scale-modes/locrian/Fsharp.png";

//chords
//major
import Maj7_Chord_A from "../app/images/high-res-chord-pics/Maj7/A.png";
import Maj7_Chord_Csharp from "../app/images/high-res-chord-pics/Maj7/Csharp.png";
import Maj7_Chord_D from "../app/images/high-res-chord-pics/Maj7/D.png";
import Maj7_Chord_F from "../app/images/high-res-chord-pics/Maj7/F.png";

//dominant
import Dom7_Chord_Ab from "../app/images/high-res-chord-pics/Dom7/Ab.png";
import Dom7_Chord_B from "../app/images/high-res-chord-pics/Dom7/B.png";
import Dom7_Chord_D from "../app/images/high-res-chord-pics/Dom7/D.png";
import Dom7_Chord_F from "../app/images/high-res-chord-pics/Dom7/F.png";

//minor
import Min7_Chord_Ab from "../app/images/high-res-chord-pics/Min7/Ab.png";
import Min7_Chord_B from "../app/images/high-res-chord-pics/Min7/B.png";
import Min7_Chord_Eb from "../app/images/high-res-chord-pics/Min7/Eb.png";
import Min7_Chord_G from "../app/images/high-res-chord-pics/Min7/G.png";

//half-dim
import Half_Dim7_Chord_B from "../app/images/high-res-chord-pics/half-dim7/B.png";
import Half_Dim7_Chord_D from "../app/images/high-res-chord-pics/half-dim7/D.png";
import Half_Dim7_Chord_E from "../app/images/high-res-chord-pics/half-dim7/E.png";
import Half_Dim7_Chord_Eb from "../app/images/high-res-chord-pics/half-dim7/Eb.png";

//fully dim
import Dim7_Chord_B from "../app/images/high-res-chord-pics/diminished7/B.png";
import Dim7_Chord_Csharp from "../app/images/high-res-chord-pics/diminished7/Csharp.png";
import Dim7_Chord_E from "../app/images/high-res-chord-pics/diminished7/E.png";
import Dim7_Chord_G from "../app/images/high-res-chord-pics/diminished7/G.png";

//maj7#5
import Maj_7_sharp_5_Bb from "../app/images/high-res-chord-pics/maj7sharp5/Bb.png";
import Maj_7_sharp_5_C from "../app/images/high-res-chord-pics/maj7sharp5/C.png";
import Maj_7_sharp_5_Eb from "../app/images/high-res-chord-pics/maj7sharp5/Eb.png";
import Maj_7_sharp_5_G from "../app/images/high-res-chord-pics/maj7sharp5/G.png";

//dom7#5
import Dom_7_sharp_5_C from "../app/images/high-res-chord-pics/dom7sharp5/C.png";
import Dom_7_sharp_5_E from "../app/images/high-res-chord-pics/dom7sharp5/E.png";
import Dom_7_sharp_5_F from "../app/images/high-res-chord-pics/dom7sharp5/F.png";
import Dom_7_sharp_5_G from "../app/images/high-res-chord-pics/dom7sharp5/G.png";

//dom7sus4
import Dom_7_sus_4_B from "../app/images/high-res-chord-pics/dom7sus4/B.png";
import Dom_7_sus_4_Bb from "../app/images/high-res-chord-pics/dom7sus4/Bb.png";
import Dom_7_sus_4_D from "../app/images/high-res-chord-pics/dom7sus4/D.png";
import Dom_7_sus_4_Eb from "../app/images/high-res-chord-pics/dom7sus4/Eb.png";

//modes
const modeQuestion = "What mode of the major scale is this?";
const Ionian = "Ionian";
const Dorian = "Dorian";
const Phrygian = "Phrygian";
const Lydian = "Lydian";
const Mixolydian = "Mixolydian";
const Aeolian = "Aeolian";
const Locrian = "Locrian";

const ModesOfTheMajorScale = "Modes of the Major Scale";

export const ModeQuestions = [
  //no images
  {
    id: 0,
    title: ModesOfTheMajorScale,
    question: "What is the 2nd mode of the major scale?",
    answer: Dorian,
  },
  {
    id: 1,
    title: ModesOfTheMajorScale,
    question: "What is the 3rd mode of the major scale?",
    answer: Phrygian,
  },
  {
    id: 2,
    title: ModesOfTheMajorScale,
    question: "What is the 4th mode of the major scale?",
    answer: Lydian,
  },
  {
    id: 3,
    title: ModesOfTheMajorScale,
    question: "What is the 5th mode of the major scale?",
    answer: Mixolydian,
  },
  {
    id: 4,
    title: ModesOfTheMajorScale,
    question: "What is the 6th mode of the major scale?",
    answer: Aeolian,
  },
  {
    id: 5,
    title: ModesOfTheMajorScale,
    question: "What is the 7th mode of the major scale?",
    answer: Locrian,
  },
  {
    id: 6,
    title: ModesOfTheMajorScale,
    question: "What is the 1st mode of the major scale?",
    answer: Ionian,
  },
  //mode questions with images
  //ionian
  {
    id: 7,
    title: ModesOfTheMajorScale,
    image: Ionian_Mode_Ab,
    question: modeQuestion,
    answer: Ionian,
  },
  {
    id: 8,
    title: ModesOfTheMajorScale,
    image: Ionian_Mode_Csharp,
    question: modeQuestion,
    answer: Ionian,
  },
  {
    id: 9,
    title: ModesOfTheMajorScale,
    image: Ionian_Mode_Db,
    question: modeQuestion,
    answer: Ionian,
  },
  {
    id: 10,
    title: ModesOfTheMajorScale,
    image: Ionian_Mode_E,
    question: modeQuestion,
    answer: Ionian,
  },
  //dorian
  {
    id: 11,
    title: ModesOfTheMajorScale,
    image: Dorian_Mode_B,
    question: modeQuestion,
    answer: Dorian,
  },
  {
    id: 12,
    title: ModesOfTheMajorScale,
    image: Dorian_Mode_D,
    question: modeQuestion,
    answer: Dorian,
  },
  {
    id: 13,
    title: ModesOfTheMajorScale,
    image: Dorian_Mode_Eb,
    question: modeQuestion,
    answer: Dorian,
  },
  {
    id: 14,
    title: ModesOfTheMajorScale,
    image: Dorian_Mode_F,
    question: modeQuestion,
    answer: Dorian,
  },
  //phrygian
  {
    id: 15,
    title: ModesOfTheMajorScale,
    image: Phrygian_Mode_Asharp,
    question: modeQuestion,
    answer: Phrygian,
  },
  {
    id: 16,
    title: ModesOfTheMajorScale,
    image: Phrygian_Mode_C,
    question: modeQuestion,
    answer: Phrygian,
  },
  {
    id: 17,
    title: ModesOfTheMajorScale,
    image: Phrygian_Mode_E,
    question: modeQuestion,
    answer: Phrygian,
  },
  {
    id: 18,
    title: ModesOfTheMajorScale,
    image: Phrygian_Mode_Fsharp,
    question: modeQuestion,
    answer: Phrygian,
  },
  //lydian
  {
    id: 19,
    title: ModesOfTheMajorScale,
    image: Lydian_Mode_B,
    question: modeQuestion,
    answer: Lydian,
  },
  {
    id: 20,
    title: ModesOfTheMajorScale,
    image: Lydian_Mode_Bb,
    question: modeQuestion,
    answer: Lydian,
  },
  {
    id: 21,
    title: ModesOfTheMajorScale,
    image: Lydian_Mode_Eb,
    question: modeQuestion,
    answer: Lydian,
  },
  {
    id: 22,
    title: ModesOfTheMajorScale,
    image: Lydian_Mode_F,
    question: modeQuestion,
    answer: Lydian,
  },
  //mixo
  {
    id: 23,
    title: ModesOfTheMajorScale,
    image: Mixo_Mode_Bb,
    question: modeQuestion,
    answer: Mixolydian,
  },
  {
    id: 24,
    title: ModesOfTheMajorScale,
    image: Mixo_Mode_C,
    question: modeQuestion,
    answer: Mixolydian,
  },
  {
    id: 25,
    title: ModesOfTheMajorScale,
    image: Mixo_Mode_E,
    question: modeQuestion,
    answer: Mixolydian,
  },
  {
    id: 26,
    title: ModesOfTheMajorScale,
    image: Mixo_Mode_Fsharp,
    question: modeQuestion,
    answer: Mixolydian,
  },
  //aeolian
  {
    id: 27,
    title: ModesOfTheMajorScale,
    image: Aeolian_Mode_B,
    question: modeQuestion,
    answer: Aeolian,
  },
  {
    id: 28,
    title: ModesOfTheMajorScale,
    image: Aeolian_Mode_C,
    question: modeQuestion,
    answer: Aeolian,
  },
  {
    id: 29,
    title: ModesOfTheMajorScale,
    image: Aeolian_Mode_D,
    question: modeQuestion,
    answer: Aeolian,
  },
  {
    id: 30,
    title: ModesOfTheMajorScale,
    image: Aeolian_Mode_Gsharp,
    question: modeQuestion,
    answer: Aeolian,
  },
  //locrian
  {
    id: 31,
    title: ModesOfTheMajorScale,
    image: Locrian_Mode_Asharp,
    question: modeQuestion,
    answer: Locrian,
  },
  {
    id: 32,
    title: ModesOfTheMajorScale,
    image: Locrian_Mode_Bsharp,
    question: modeQuestion,
    answer: Locrian,
  },
  {
    id: 33,
    title: ModesOfTheMajorScale,
    image: Locrian_Mode_D,
    question: modeQuestion,
    answer: Locrian,
  },
  {
    id: 34,
    title: ModesOfTheMajorScale,
    image: Locrian_Mode_Fsharp,
    question: modeQuestion,
    answer: Locrian,
  },
];

const majorKeySig = "What is this major key signature?";
const minorKeySig = "What is this relative minor key signature?";
const topicKeySignatures = "Key Signatures";

export const KeySignatureQuestions = [
  {
    id: 0,
    title: topicKeySignatures,
    image: A_maj_key_sig,
    question: majorKeySig,
    answer: "A Major",
  },
  {
    id: 1,
    title: topicKeySignatures,
    image: Ab_maj_key_sig,
    question: majorKeySig,
    answer: "Ab Major",
  },
  {
    id: 2,
    title: topicKeySignatures,
    image: B_maj_key_sig,
    question: majorKeySig,
    answer: "B Major",
  },
  {
    id: 3,
    title: topicKeySignatures,
    image: Bb_maj_key_sig,
    question: majorKeySig,
    answer: "Bb Major",
  },
  {
    id: 4,
    title: topicKeySignatures,
    image: C_maj_key_sig,
    question: majorKeySig,
    answer: "C Major",
  },
  {
    id: 5,
    title: topicKeySignatures,
    image: Csharp_maj_key_sig,
    question: majorKeySig,
    answer: "C# Major",
  },
  {
    id: 6,
    title: topicKeySignatures,
    image: Cb_maj_key_sig,
    question: majorKeySig,
    answer: "Cb Major",
  },
  {
    id: 7,
    title: topicKeySignatures,
    image: D_maj_key_sig,
    question: majorKeySig,
    answer: "D Major",
  },
  {
    id: 8,
    title: topicKeySignatures,
    image: Db_maj_key_sig,
    question: majorKeySig,
    answer: "Db Major",
  },
  {
    id: 9,
    title: topicKeySignatures,
    image: E_maj_key_sig,
    question: majorKeySig,
    answer: "E Major",
  },
  {
    id: 10,
    title: topicKeySignatures,
    image: Eb_maj_key_sig,
    question: majorKeySig,
    answer: "Eb Major",
  },
  {
    id: 11,
    title: topicKeySignatures,
    image: F_maj_key_sig,
    question: majorKeySig,
    answer: "F Major",
  },
  {
    id: 12,
    title: topicKeySignatures,
    image: Fsharp_maj_key_sig,
    question: majorKeySig,
    answer: "F# Major",
  },
  {
    id: 13,
    title: topicKeySignatures,
    image: G_maj_key_sig,
    question: majorKeySig,
    answer: "G Major",
  },
  {
    id: 14,
    title: topicKeySignatures,
    image: Gb_maj_key_sig,
    question: majorKeySig,
    answer: "Gb Major",
  },
  {
    id: 15,
    title: topicKeySignatures,
    image: A_maj_key_sig,
    question: minorKeySig,
    answer: "F# minor",
  },
  {
    id: 16,
    title: topicKeySignatures,
    image: Ab_maj_key_sig,
    question: minorKeySig,
    answer: "F minor",
  },
  {
    id: 17,
    title: topicKeySignatures,
    image: B_maj_key_sig,
    question: minorKeySig,
    answer: "G# minor",
  },
  {
    id: 18,
    title: topicKeySignatures,
    image: Bb_maj_key_sig,
    question: minorKeySig,
    answer: "G minor",
  },
  {
    id: 19,
    title: topicKeySignatures,
    image: C_maj_key_sig,
    question: minorKeySig,
    answer: "A minor",
  },
  {
    id: 20,
    title: topicKeySignatures,
    image: Cb_maj_key_sig,
    question: minorKeySig,
    answer: "Ab minor",
  },
  {
    id: 21,
    title: topicKeySignatures,
    image: Csharp_maj_key_sig,
    question: minorKeySig,
    answer: "A# minor",
  },
  {
    id: 22,
    title: topicKeySignatures,
    image: D_maj_key_sig,
    question: minorKeySig,
    answer: "B minor",
  },
  {
    id: 23,
    title: topicKeySignatures,
    image: Db_maj_key_sig,
    question: minorKeySig,
    answer: "Bb minor",
  },
  {
    id: 24,
    title: topicKeySignatures,
    image: E_maj_key_sig,
    question: minorKeySig,
    answer: "C# minor",
  },
  {
    id: 25,
    title: topicKeySignatures,
    image: Eb_maj_key_sig,
    question: minorKeySig,
    answer: "C minor",
  },
  {
    id: 26,
    title: topicKeySignatures,
    image: F_maj_key_sig,
    question: minorKeySig,
    answer: "D minor",
  },
  {
    id: 27,
    title: topicKeySignatures,
    image: Fsharp_maj_key_sig,
    question: minorKeySig,
    answer: "D# minor",
  },
  {
    id: 28,
    title: topicKeySignatures,
    image: G_maj_key_sig,
    question: minorKeySig,
    answer: "E minor",
  },
  {
    id: 29,
    title: topicKeySignatures,
    image: Gb_maj_key_sig,
    question: minorKeySig,
    answer: "Eb minor",
  },
];

const ChordQualityQuestion = "What type of chord is this?";
const ChordTopic = "Chords";
const major7th = "Major 7th";
const dominant7 = "Dominant 7th";
const minor7 = "Minor 7th";
const half_diminished7 = "Half-Diminished 7th (Minor 7b5)";
const diminished7 = "Diminished 7th";
const major7sharp5 = "Major 7#5";
const dom7sharp5 = "Dominant 7#5";
const dom7sus4 = "Dominant 7sus4";

export const ChordQuestions = [
  //major
  {
    id: 0,
    title: ChordTopic,
    image: Maj7_Chord_A,
    question: ChordQualityQuestion,
    answer: major7th,
  },
  {
    id: 1,
    title: ChordTopic,
    image: Maj7_Chord_Csharp,
    question: ChordQualityQuestion,
    answer: major7th,
  },
  {
    id: 2,
    title: ChordTopic,
    image: Maj7_Chord_D,
    question: ChordQualityQuestion,
    answer: major7th,
  },
  {
    id: 3,
    title: ChordTopic,
    image: Maj7_Chord_F,
    question: ChordQualityQuestion,
    answer: major7th,
  },
  //dominant
  {
    id: 4,
    title: ChordTopic,
    image: Dom7_Chord_Ab,
    question: ChordQualityQuestion,
    answer: dominant7,
  },
  {
    id: 5,
    title: ChordTopic,
    image: Dom7_Chord_B,
    question: ChordQualityQuestion,
    answer: dominant7,
  },
  {
    id: 6,
    title: ChordTopic,
    image: Dom7_Chord_D,
    question: ChordQualityQuestion,
    answer: dominant7,
  },
  {
    id: 7,
    title: ChordTopic,
    image: Dom7_Chord_F,
    question: ChordQualityQuestion,
    answer: dominant7,
  },
  //minor
  {
    id: 8,
    title: ChordTopic,
    image: Min7_Chord_Ab,
    question: ChordQualityQuestion,
    answer: minor7,
  },
  {
    id: 9,
    title: ChordTopic,
    image: Min7_Chord_B,
    question: ChordQualityQuestion,
    answer: minor7,
  },
  {
    id: 10,
    title: ChordTopic,
    image: Min7_Chord_Eb,
    question: ChordQualityQuestion,
    answer: minor7,
  },
  {
    id: 11,
    title: ChordTopic,
    image: Min7_Chord_G,
    question: ChordQualityQuestion,
    answer: minor7,
  },
  //half-dim
  {
    id: 12,
    title: ChordTopic,
    image: Half_Dim7_Chord_B,
    question: ChordQualityQuestion,
    answer: half_diminished7,
  },
  {
    id: 13,
    title: ChordTopic,
    image: Half_Dim7_Chord_D,
    question: ChordQualityQuestion,
    answer: half_diminished7,
  },
  {
    id: 14,
    title: ChordTopic,
    image: Half_Dim7_Chord_E,
    question: ChordQualityQuestion,
    answer: half_diminished7,
  },
  {
    id: 15,
    title: ChordTopic,
    image: Half_Dim7_Chord_Eb,
    question: ChordQualityQuestion,
    answer: half_diminished7,
  },
  //fully-dim
  {
    id: 16,
    title: ChordTopic,
    image: Dim7_Chord_B,
    question: ChordQualityQuestion,
    answer: diminished7,
  },
  {
    id: 17,
    title: ChordTopic,
    image: Dim7_Chord_Csharp,
    question: ChordQualityQuestion,
    answer: diminished7,
  },
  {
    id: 18,
    title: ChordTopic,
    image: Dim7_Chord_E,
    question: ChordQualityQuestion,
    answer: diminished7,
  },
  {
    id: 19,
    title: ChordTopic,
    image: Dim7_Chord_G,
    question: ChordQualityQuestion,
    answer: diminished7,
  },
  //maj7#5
  {
    id: 20,
    title: ChordTopic,
    image: Maj_7_sharp_5_Bb,
    question: ChordQualityQuestion,
    answer: major7sharp5,
  },
  {
    id: 21,
    title: ChordTopic,
    image: Maj_7_sharp_5_C,
    question: ChordQualityQuestion,
    answer: major7sharp5,
  },
  {
    id: 22,
    title: ChordTopic,
    image: Maj_7_sharp_5_Eb,
    question: ChordQualityQuestion,
    answer: major7sharp5,
  },
  {
    id: 23,
    title: ChordTopic,
    image: Maj_7_sharp_5_G,
    question: ChordQualityQuestion,
    answer: major7sharp5,
  },
  //dom7#5
  {
    id: 24,
    title: ChordTopic,
    image: Dom_7_sharp_5_C,
    question: ChordQualityQuestion,
    answer: dom7sharp5,
  },
  {
    id: 25,
    title: ChordTopic,
    image: Dom_7_sharp_5_E,
    question: ChordQualityQuestion,
    answer: dom7sharp5,
  },
  {
    id: 26,
    title: ChordTopic,
    image: Dom_7_sharp_5_F,
    question: ChordQualityQuestion,
    answer: dom7sharp5,
  },
  {
    id: 27,
    title: ChordTopic,
    image: Dom_7_sharp_5_G,
    question: ChordQualityQuestion,
    answer: dom7sharp5,
  },
  //dom7sus4
  {
    id: 28,
    title: ChordTopic,
    image: Dom_7_sus_4_B,
    question: ChordQualityQuestion,
    answer: dom7sus4,
  },
  {
    id: 29,
    title: ChordTopic,
    image: Dom_7_sus_4_Bb,
    question: ChordQualityQuestion,
    answer: dom7sus4,
  },
  {
    id: 30,
    title: ChordTopic,
    image: Dom_7_sus_4_D,
    question: ChordQualityQuestion,
    answer: dom7sus4,
  },
  {
    id: 31,
    title: ChordTopic,
    image: Dom_7_sus_4_Eb,
    question: ChordQualityQuestion,
    answer: dom7sus4,
  },
];

const intervalTopic = "Intervals";
const intervalQuestion = "What interval is this?";

//major ascending titles
const Major2nd = "Major 2nd";
const Major3rd = "Major 3rd";
const Perfect4th = "Perfect 4th";
const Perfect5th = "Perfect 5th";
const Major6th = "Major 6th";
const Major7th = "Major 7th";

//major descending titles
const DescendingMajor2nd = "Major 2nd";
const DescendingMajor3rd = "Major 3rd";
const DescendingPerfect4th = "Perfect 4th";
const DescendingPerfect5th = "Perfect 5th";
const DescendingMajor6th = "Major 6th";
const DescendingMajor7th = "Major 7th";

//chromatic ascending titles
const AscendingMinor2nd = "Minor 2nd";
const AscendingMinor3rd = "Minor 3rd";
const AscendingAugmented4th = "Augmented 4th (tri-tone)";
const AscendingMinor6th = "Minor 6th";
const AscendingMinor7th = "Minor 7th";

//chromatic descending titles
const DescendingMinor2nd = "Minor 2nd";
const DescendingMinor3rd = "Minor 3rd";
const DescendingDiminished5th = "Diminished 5th (tri-tone)";
const DescendingMinor6th = "Minor 6th";
const DescendingMinor7th = "Minor 7th";

export const IntervalQuestions = [
  //major 2nds
  {
    id: 0,
    title: intervalTopic,
    image: Ascending_Maj_2nd_C_to_D,
    question: intervalQuestion,
    answer: Major2nd,
  },
  {
    id: 1,
    title: intervalTopic,
    image: Ascending_Maj_2nd_E_to_Fsharp,
    question: intervalQuestion,
    answer: Major2nd,
  },
  {
    id: 2,
    title: intervalTopic,
    image: Ascending_Maj_2nd_F_to_G,
    question: intervalQuestion,
    answer: Major2nd,
  },
  {
    id: 3,
    title: intervalTopic,
    image: Ascending_Maj_2nd_Fsharp_to_Gsharp,
    question: intervalQuestion,
    answer: Major2nd,
  },

  //major 3rds
  {
    id: 4,
    title: intervalTopic,
    image: Ascending_Maj_3rd_D_to_Fsharp,
    question: intervalQuestion,
    answer: Major3rd,
  },
  {
    id: 5,
    title: intervalTopic,
    image: Ascending_Maj_3rd_Eb_to_G,
    question: intervalQuestion,
    answer: Major3rd,
  },
  {
    id: 6,
    title: intervalTopic,
    image: Ascending_Maj_3rd_High_Bb_to_D,
    question: intervalQuestion,
    answer: Major3rd,
  },
  {
    id: 6,
    title: intervalTopic,
    image: Ascending_Maj_3rd_High_D_to_Fsharp,
    question: intervalQuestion,
    answer: Major3rd,
  },
  {
    id: 7,
    title: intervalTopic,
    image: Ascending_Maj_3rd_Low_B_to_Dsharp,
    question: intervalQuestion,
    answer: Major3rd,
  },

  //perfect 4ths
  {
    id: 8,
    title: intervalTopic,
    image: Ascending_Perf_4th_BtoE,
    question: intervalQuestion,
    answer: Perfect4th,
  },
  {
    id: 9,
    title: intervalTopic,
    image: Ascending_Perf_4th_EbToAb,
    question: intervalQuestion,
    answer: Perfect4th,
  },
  {
    id: 10,
    title: intervalTopic,
    image: Ascending_Perf_4th_FsharpToB,
    question: intervalQuestion,
    answer: Perfect4th,
  },
  {
    id: 11,
    title: intervalTopic,
    image: Ascending_Perf_4th_FtoBb,
    question: intervalQuestion,
    answer: Perfect4th,
  },

  //perfect 5ths
  {
    id: 12,
    title: intervalTopic,
    image: Ascending_Perf_5th_CsharpToGsharp,
    question: intervalQuestion,
    answer: Perfect5th,
  },
  {
    id: 13,
    title: intervalTopic,
    image: Ascending_Perf_5th_FsharpToCsharp,
    question: intervalQuestion,
    answer: Perfect5th,
  },
  {
    id: 14,
    title: intervalTopic,
    image: Ascending_Perf_5th_HighGtoHighC,
    question: intervalQuestion,
    answer: Perfect5th,
  },
  {
    id: 15,
    title: intervalTopic,
    image: Ascending_Perf_5th_LowCtoG,
    question: intervalQuestion,
    answer: Perfect5th,
  },

  //major 6ths
  {
    id: 16,
    title: intervalTopic,
    image: Ascending_Maj_6th_Eb_to_C,
    question: intervalQuestion,
    answer: Major6th,
  },
  {
    id: 17,
    title: intervalTopic,
    image: Ascending_Maj_6th_E_to_Csharp,
    question: intervalQuestion,
    answer: Major6th,
  },
  {
    id: 18,
    title: intervalTopic,
    image: Ascending_Maj_6th_Fsharp_to_Dsharp,
    question: intervalQuestion,
    answer: Major6th,
  },
  {
    id: 19,
    title: intervalTopic,
    image: Ascending_Maj_6th_High_F_to_D,
    question: intervalQuestion,
    answer: Major6th,
  },
  {
    id: 20,
    title: intervalTopic,
    image: Ascending_Maj_6th_Low_Bb_to_G,
    question: intervalQuestion,
    answer: Major6th,
  },

  //major 7ths
  {
    id: 21,
    title: intervalTopic,
    image: Ascending_Maj_7th_Bb_to_A,
    question: intervalQuestion,
    answer: Major7th,
  },
  {
    id: 22,
    title: intervalTopic,
    image: Ascending_Maj_7th_LowF_to_E,
    question: intervalQuestion,
    answer: Major7th,
  },
  {
    id: 23,
    title: intervalTopic,
    image: Ascending_Maj_7th_Low_B_to_Asharp,
    question: intervalQuestion,
    answer: Major7th,
  },
  {
    id: 24,
    title: intervalTopic,
    image: Ascending_Maj_7th_Low_Csharp_to_C,
    question: intervalQuestion,
    answer: Major7th,
  },

  //descending major 2nds
  {
    id: 25,
    title: intervalTopic,
    image: Descending_Maj_2nd_AsharpToGsharp,
    question: intervalQuestion,
    answer: DescendingMajor2nd,
  },
  {
    id: 26,
    title: intervalTopic,
    image: Descending_Maj_2nd_G_to_F,
    question: intervalQuestion,
    answer: DescendingMajor2nd,
  },
  {
    id: 27,
    title: intervalTopic,
    image: Descending_Maj_2nd_Gsharp_to_Fsharp,
    question: intervalQuestion,
    answer: DescendingMajor2nd,
  },
  {
    id: 28,
    title: intervalTopic,
    image: Descending_Maj_2nd_High_Csharp_to_B,
    question: intervalQuestion,
    answer: DescendingMajor2nd,
  },
  {
    id: 29,
    title: intervalTopic,
    image: Descending_Maj_2nd_High_Dsharp_to_Csharp,
    question: intervalQuestion,
    answer: DescendingMajor2nd,
  },
  {
    id: 30,
    title: intervalTopic,
    image: Descending_Maj_2nd_High_E_to_C,
    question: intervalQuestion,
    answer: DescendingMajor2nd,
  },
  {
    id: 31,
    title: intervalTopic,
    image: Descending_Maj_2nd_Low_C_to_Bb,
    question: intervalQuestion,
    answer: DescendingMajor2nd,
  },

  //descending major 3rds
  {
    id: 32,
    title: intervalTopic,
    image: Descending_Maj_3rd_Csharp_to_A,
    question: intervalQuestion,
    answer: DescendingMajor3rd,
  },
  {
    id: 33,
    title: intervalTopic,
    image: Descending_Maj_3rd_F_to_Db,
    question: intervalQuestion,
    answer: DescendingMajor3rd,
  },
  {
    id: 34,
    title: intervalTopic,
    image: Descending_Maj_3rd_High_B_to_G,
    question: intervalQuestion,
    answer: DescendingMajor3rd,
  },
  {
    id: 35,
    title: intervalTopic,
    image: Descending_Maj_3rd_Low_D_to_Bb,
    question: intervalQuestion,
    answer: DescendingMajor3rd,
  },

  //descending perfect 4ths
  {
    id: 36,
    title: intervalTopic,
    image: Descending_Perf_4th_Csharp_to_Gsharp,
    question: intervalQuestion,
    answer: DescendingPerfect4th,
  },
  {
    id: 37,
    title: intervalTopic,
    image: Descending_Perf_4th_E_to_A,
    question: intervalQuestion,
    answer: DescendingPerfect4th,
  },
  {
    id: 38,
    title: intervalTopic,
    image: Descending_Perf_4th_High_Eb_to_Bb,
    question: intervalQuestion,
    answer: DescendingPerfect4th,
  },
  {
    id: 39,
    title: intervalTopic,
    image: Descending_Perf_4th_High_F_to_C,
    question: intervalQuestion,
    answer: DescendingPerfect4th,
  },

  //descending perfect 5ths
  {
    id: 40,
    title: intervalTopic,
    image: Descending_Perf_5th_D_to_G,
    question: intervalQuestion,
    answer: DescendingPerfect5th,
  },
  {
    id: 41,
    title: intervalTopic,
    image: Descending_Perf_5th_Gsharp_to_Csharp,
    question: intervalQuestion,
    answer: DescendingPerfect5th,
  },
  {
    id: 42,
    title: intervalTopic,
    image: Descending_Perf_5th_High_F_to_Bb,
    question: intervalQuestion,
    answer: DescendingPerfect5th,
  },
  {
    id: 43,
    title: intervalTopic,
    image: Descending_Perf_5th_Low_Fsharp_to_B,
    question: intervalQuestion,
    answer: DescendingPerfect5th,
  },

  //descending major 6ths
  {
    id: 44,
    title: intervalTopic,
    image: Descending_Maj_6th_Bb_to_Db,
    question: intervalQuestion,
    answer: DescendingMajor6th,
  },
  {
    id: 45,
    title: intervalTopic,
    image: Descending_Maj_6th_G_to_Low_Bb,
    question: intervalQuestion,
    answer: DescendingMajor6th,
  },
  {
    id: 46,
    title: intervalTopic,
    image: Descending_Maj_6th_High_D_to_F,
    question: intervalQuestion,
    answer: DescendingMajor6th,
  },
  {
    id: 47,
    title: intervalTopic,
    image: Descending_Maj_6th_High_E_to_G,
    question: intervalQuestion,
    answer: DescendingMajor6th,
  },

  //descending major 7ths
  {
    id: 48,
    title: intervalTopic,
    image: Descending_Maj_7th_Asharp_to_Low_B,
    question: intervalQuestion,
    answer: DescendingMajor7th,
  },
  {
    id: 49,
    title: intervalTopic,
    image: Descending_Maj_7th_F_to_Fsharp,
    question: intervalQuestion,
    answer: DescendingMajor7th,
  },
  {
    id: 50,
    title: intervalTopic,
    image: Descending_Maj_7th_G_to_Ab,
    question: intervalQuestion,
    answer: DescendingMajor7th,
  },
  {
    id: 51,
    title: intervalTopic,
    image: Descending_Maj_7th_High_E_to_F,
    question: intervalQuestion,
    answer: DescendingMajor7th,
  },

  //ascending chromatic intervals

  //ascending minor 2nds
  {
    id: 52,
    title: intervalTopic,
    image: Ascending_Chromatic_Min_2nd_High_Asharp_to_B,
    question: intervalQuestion,
    answer: AscendingMinor2nd,
  },
  {
    id: 53,
    title: intervalTopic,
    image: Ascending_Chromatic_Min_2nd_High_D_to_Eb,
    question: intervalQuestion,
    answer: AscendingMinor2nd,
  },
  {
    id: 54,
    title: intervalTopic,
    image: Ascending_Chromatic_Min_2nd_Low_C_to_Csharp,
    question: intervalQuestion,
    answer: AscendingMinor2nd,
  },
  {
    id: 55,
    title: intervalTopic,
    image: Ascending_Chromatic_Min_2nd_Low_F_to_Fsharp,
    question: intervalQuestion,
    answer: AscendingMinor2nd,
  },

  //ascending minor 3rds
  {
    id: 56,
    title: intervalTopic,
    image: Ascending_Chromatic_Min_3rd_C_sharp_to_E,
    question: intervalQuestion,
    answer: AscendingMinor3rd,
  },
  {
    id: 57,
    title: intervalTopic,
    image: Ascending_Chromatic_Min_3rd_High_F_to_Ab,
    question: intervalQuestion,
    answer: AscendingMinor3rd,
  },
  {
    id: 58,
    title: intervalTopic,
    image: Ascending_Chromatic_Min_3rd_Low_B_to_D,
    question: intervalQuestion,
    answer: AscendingMinor3rd,
  },
  {
    id: 59,
    title: intervalTopic,
    image: Ascending_Chromatic_Min_3rd_Low_Eb_to_Gb,
    question: intervalQuestion,
    answer: AscendingMinor3rd,
  },

  //ascending augmented 4ths
  {
    id: 60,
    title: intervalTopic,
    image: Ascending_Chromatic_Aug_4th_B_to_F,
    question: intervalQuestion,
    answer: AscendingAugmented4th,
  },
  {
    id: 61,
    title: intervalTopic,
    image: Ascending_Chromatic_Aug_4th_E_to_Bb,
    question: intervalQuestion,
    answer: AscendingAugmented4th,
  },
  {
    id: 62,
    title: intervalTopic,
    image: Ascending_Chromatic_Aug_4th_F_to_B,
    question: intervalQuestion,
    answer: AscendingAugmented4th,
  },
  {
    id: 63,
    title: intervalTopic,
    image: Ascending_Chromatic_Aug_4th_Bb_to_E,
    question: intervalQuestion,
    answer: AscendingAugmented4th,
  },

  //ascending minor 6ths
  {
    id: 64,
    title: intervalTopic,
    image: Ascending_Chromatic_Min_6th_A_to_F,
    question: intervalQuestion,
    answer: AscendingMinor6th,
  },
  {
    id: 65,
    title: intervalTopic,
    image: Ascending_Chromatic_Min_6th_Csharp_to_A,
    question: intervalQuestion,
    answer: AscendingMinor6th,
  },
  {
    id: 66,
    title: intervalTopic,
    image: Ascending_Chromatic_Min_6th_Low_Bb_to_Gb,
    question: intervalQuestion,
    answer: AscendingMinor6th,
  },
  {
    id: 67,
    title: intervalTopic,
    image: Ascending_Chromatic_Min_6th_Low_E_to_C,
    question: intervalQuestion,
    answer: AscendingMinor6th,
  },

  //ascending minor 7ths
  {
    id: 68,
    title: intervalTopic,
    image: Ascending_Chromatic_Min_7th_E_to_D,
    question: intervalQuestion,
    answer: AscendingMinor7th,
  },
  {
    id: 69,
    title: intervalTopic,
    image: Ascending_Chromatic_Min_7th_F_to_Eb,
    question: intervalQuestion,
    answer: AscendingMinor7th,
  },
  {
    id: 70,
    title: intervalTopic,
    image: Ascending_Chromatic_Min_7th_Low_Bb_to_Ab,
    question: intervalQuestion,
    answer: AscendingMinor7th,
  },
  {
    id: 71,
    title: intervalTopic,
    image: Ascending_Chromatic_Min_7th_Low_Csharp_to_B,
    question: intervalQuestion,
    answer: AscendingMinor7th,
  },

  //descending chromatic intervals
  //min 2nds
  {
    id: 72,
    title: intervalTopic,
    image: Descending_Chromatic_Min_2nd_A_sharp_to_A,
    question: intervalQuestion,
    answer: DescendingMinor2nd,
  },
  {
    id: 73,
    title: intervalTopic,
    image: Descending_Chromatic_Min_2nd_F_to_E,
    question: intervalQuestion,
    answer: DescendingMinor2nd,
  },
  {
    id: 74,
    title: intervalTopic,
    image: Descending_Chromatic_Min_2nd_High_Fsharp_to_F,
    question: intervalQuestion,
    answer: DescendingMinor2nd,
  },
  {
    id: 75,
    title: intervalTopic,
    image: Descending_Chromatic_Min_2nd_E_to_Eb,
    question: intervalQuestion,
    answer: DescendingMinor2nd,
  },

  //min 3rds
  {
    id: 76,
    title: intervalTopic,
    image: Descending_Chromatic_Min_3rd_Ab_to_F,
    question: intervalQuestion,
    answer: DescendingMinor3rd,
  },
  {
    id: 77,
    title: intervalTopic,
    image: Descending_Chromatic_Min_3rd_Bb_to_G,
    question: intervalQuestion,
    answer: DescendingMinor3rd,
  },
  {
    id: 78,
    title: intervalTopic,
    image: Descending_Chromatic_Min_3rd_C_to_A,
    question: intervalQuestion,
    answer: DescendingMinor3rd,
  },
  {
    id: 79,
    title: intervalTopic,
    image: Descending_Chromatic_Min_3rd_High_Csharp_to_A_sharp,
    question: intervalQuestion,
    answer: DescendingMinor3rd,
  },

  //dim 5th
  {
    id: 80,
    title: intervalTopic,
    image: Descending_Chromatic_Dim_5th_B_to_F,
    question: intervalQuestion,
    answer: DescendingDiminished5th,
  },
  {
    id: 81,
    title: intervalTopic,
    image: Descending_Chromatic_Dim_5th_D_to_Ab,
    question: intervalQuestion,
    answer: DescendingDiminished5th,
  },
  {
    id: 82,
    title: intervalTopic,
    image: Descending_Chromatic_Dim_5th_Eb_to_A,
    question: intervalQuestion,
    answer: DescendingDiminished5th,
  },
  {
    id: 83,
    title: intervalTopic,
    image: Descending_Chromatic_Dim_5th_G_to_C_sharp,
    question: intervalQuestion,
    answer: DescendingDiminished5th,
  },

  //minor 6ths
  {
    id: 84,
    title: intervalTopic,
    image: Descending_Chromatic_Min_6th_A_to_Csharp,
    question: intervalQuestion,
    answer: DescendingMinor6th,
  },
  {
    id: 85,
    title: intervalTopic,
    image: Descending_Chromatic_Min_6th_D_to_Fsharp,
    question: intervalQuestion,
    answer: DescendingMinor6th,
  },
  {
    id: 86,
    title: intervalTopic,
    image: Descending_Chromatic_Min_6th_G_to_B,
    question: intervalQuestion,
    answer: DescendingMinor6th,
  },
  {
    id: 87,
    title: intervalTopic,
    image: Descending_Chromatic_Min_6th_High_A_to_C_sharp,
    question: intervalQuestion,
    answer: DescendingMinor6th,
  },

  //minor 7ths
  {
    id: 88,
    title: intervalTopic,
    image: Descending_Chromatic_Min_7th_Ab_to_Bb,
    question: intervalQuestion,
    answer: DescendingMinor7th,
  },
  {
    id: 89,
    title: intervalTopic,
    image: Descending_Chromatic_Min_7th_B_to_Csharp,
    question: intervalQuestion,
    answer: DescendingMinor7th,
  },
  {
    id: 90,
    title: intervalTopic,
    image: Descending_Chromatic_Min_7th_C_to_D,
    question: intervalQuestion,
    answer: DescendingMinor7th,
  },
  {
    id: 91,
    title: intervalTopic,
    image: Descending_Chromatic_Min_7th_F_to_G,
    question: intervalQuestion,
    answer: DescendingMinor7th,
  },
];
